import { CircleButton } from './circleButton';

export default class SettingsButton extends CircleButton {
    constructor(iconName = 'settings', withBG = true) {
        super(iconName, withBG);
    }
}
